'use client';

import type { ProductPriceFragmentFragment } from '@packages/gql/generated/shopping/graphql';
import {
  AddToBasketButtonTailwind,
  type AddToBasketButtonTailwindProps,
} from '@packages/modules/src/AddToBasketButton/AddToBasketButtonTailwind.client';
import { AddToBasketLayer } from '@packages/product/src/components/AddToBasketLayer/AddToBasketLayer.client';
import { useAbTesting } from '@packages/shared/src/abtesting/useAbTesting/useAbTesting';

export type AddToBasketButtonWithLayerProps = AddToBasketButtonTailwindProps & {
  /** can be removed after ab test */
  abTest: {
    isAbTestActive: boolean;
    price: ProductPriceFragmentFragment;
    pbk: string;
    testId: string;
  };
};

export const AddToBasketButtonWithLayer = (props: AddToBasketButtonWithLayerProps) => {
  const {
    abTest: { isAbTestActive, pbk, price, testId },
  } = props;
  const { setOutcome } = useAbTesting();
  return (
    <AddToBasketButtonTailwind
      {...props}
      // onclick can be removed after abtest
      onClick={() => {
        isAbTestActive &&
          (pbk === 'Mobiltelefone' || pbk === 'Tablets_EBookReader') &&
          setOutcome(testId, { ATB_PRICE: price.value });
      }}
    >
      {(layerData, lineItem) => <AddToBasketLayer data={layerData} lineItem={lineItem} />}
    </AddToBasketButtonTailwind>
  );
};
